export default __webpack_public_path__ + "static/media/skippedmeal_3@2x.c31962ec.jpg";